import { useState } from "react";
import SearchIcon from "../../../Icons/SearchIcon";

function SearchUser({ onSearch }) {
    const [query, setQuery] = useState("");

    const handleSubmit = (value) => {
        setQuery(value)
        onSearch(value);
    };

    return (
        <div className="flex flex-row-reverse items-center border border-slate-300 rounded-r-lg h-11 px-2 p-1 bg-primary-100">
            <input
                type="text"
                placeholder="... جستجوی موبایل"
                value={query}
                onChange={(e) => handleSubmit(e.target.value)}
                className="text-right bg-primary-100 w-72 outline-none"
            />
            <button type="submit">
                <SearchIcon />
            </button>
        </div>
    );
}
export default SearchUser;